import { useSelector } from "react-redux";

import { ComponentDailyCheckIn } from "@components";
import { selectAuth } from "@redux";


export const PageDailyCheckIn = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentDailyCheckIn
            memberTier={memberTier} avatar={""} fullName={""} />
    );
};
